import React, { Suspense } from 'react';
import { prop, pick } from 'ramda';
import * as urlUtil from 'js/utils/url.util';
import { Link } from 'js/components/common/Link';
import { Balance } from 'js/components/main/Balance';
import { useAppSelector, useUserSelector, useDeviceSelector } from 'js/store/hooks';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';
import { BackboneReplacer } from 'js/backbone/components/BackboneReplacer';
import style from './MyBalance.scss';

export const MyBalance: React.FC = () => {
    const translate = useComponentTranslations();
    const isDesktop = useDeviceSelector(prop('isDesktop'));
    const balancePage = useAppSelector(prop('balancePage'));
    const { hideBalance } = useUserSelector(pick(['hideBalance']));
    const hideBalanceByUrl = urlUtil.getLocationParam('showHeaderOnlyOnMobile') === '1';

    if (!isDesktop && hideBalanceByUrl) {
        return null;
    }

    return (
        <>
        {isDesktop ? (
            <div className={style.desktopBalanceWrap}>
                <div className={style.balanceContainer}>
                    <Link
                        href={balancePage}
                        className={style.balanceWrap}
                        aria-label={translate('header.balance.aria-label')}
                    >
                        <span className={style.menuArrow}></span>
                        {!hideBalance && (
                            <span className={style.mobileBalance}>
                            <Suspense fallback="">
                                <Balance type="casino_gaming_balance" args='formatHeaderBalance'/>
                            </Suspense>
                            </span>
                        )}
                    </Link>
                    <div className={style.depositClone}></div>
                </div>
                <div className={style.depositContainer}>
                    <BackboneReplacer
                        dynamicName="HEADER_DEPOSIT_BUTTON"
                        viewName="headerdepositbutton"
                    />
                </div>
            </div>
        ) : (
            <div className={style.balanceContainer}>
                    <Link
                        href={balancePage}
                        className={style.balanceWrap}
                        aria-label={translate('header.balance.aria-label')}
                    >
                        <span className={style.menuArrow}></span>
                        {!hideBalance && (
                            <span className={style.mobileBalance}>
                            <Suspense fallback="">
                                <Balance type="casino_gaming_balance" args='formatHeaderBalance'/>
                            </Suspense>
                            </span>
                        )}
                    </Link>
                    <div className={style.depositContainer}>
                        <BackboneReplacer
                            dynamicName="HEADER_DEPOSIT_BUTTON"
                            viewName="headerdepositbutton"
                        />
                    </div>
            </div>
        )}
        </>
    );
};
